import Bolt from "./Bolt";

const ITEMS = ["DIAGNOSTICS", "ALTERNATORS", "STARTERS", "WIRING HARNESSES", "BATTERY REPAIR",
  "HAWAIIAN GARDENS CA", "OBD-II SCANS", "CAN-BUS FIXES", "LIGHTING", "CHARGING SYSTEMS"];

function Row({ ariaHidden }) {
  return (
    <div className="marquee-item" aria-hidden={ariaHidden || undefined}>
      {ITEMS.map((item) => (
        <span key={item} style={{ display: "flex", alignItems: "center", gap: 28 }}>
          {item}
          <Bolt className="bolt" />
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <div className="marquee" data-testid="editorial-marquee">
      <div className="marquee-track">
        <Row />
        <Row ariaHidden />
      </div>
    </div>
  );
}
